import axios from "../axiosPlugin.js";

export const getShceduleList = (data, loading = true, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/schedule/list?" + data,
    method: "get",
    data: {
      // data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getShceduleListService = (data, loading = true, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/schedule/list?",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};
export const getShceduleDetail = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/schedule/detail/" + data.id,
    method: "post",
    data: {
      // data: {},
      loading,
      isDefaultAlertTips,
    },
  });
};

export const createSchedule = (data, loading = true) => {
  return axios({
    url: "/api/schedule/create",
    method: "post",
    data: {
      data,
      loading
    },
  });
};

export const upDateSchedule = (data, loading = true) => {
  return axios({
    url: "/api/schedule/update",
    method: "put",
    data: {
      data,
      loading
    },
  });
};

export const deleteSchedule = (data, loading = true) => {
  return axios({
    url: "/api/schedule/delete/" + data.id,
    method: "delete",
    data: {
      data: {},
      loading,
    },
  });
};

export const publishSchedule = (data, loading = true) => {
  return axios({
    url: "/api/schedule/publish?scheduleId=" + data.scheduleId,
    method: "post",
    data: {
      data: {},
      loading,
    },
  });
};

export const approveSchedule = (data, loading = true) => {
  const str = `?cinemaId=${data.cinemaId}` + (data.date ? `&date=${data.date}` : "");
  return axios({
    url: `/api/schedule/approve${str}`,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const getSoldSeat = scheduleId => {
  return axios({
    url: "/api/schedule/getSoldSeat?scheduleId=" + scheduleId,
    method: "get",
    data: {},
  });
};

export const getHouseDetail = id => {
  return axios({
    url: "/api/house/detail/" + id,
    method: "get",
    data: {},
  });
};

export const createScheduleNewService = (data, loading = true) => {
  return axios({
    url: "/api/schedule/createNew",
    method: "post",
    data: {
      data,
      loading
    },
  });
};

export const getScheduleListMap = (data, loading = true) => {
  return axios({
    url: "/api/schedule/listMap",
    method: "get",
    data: {
      data,
      loading
    },
  });
};

export const exportBoardmediaCsv = (data, loading = true) => {
  return axios({
    url: `/api/schedule/exportBoardmediaCsv?cinemaId=${data.cinemaId}&startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
    data: {
      loading,
    },
  });
};

// シネマフォン連携CSV：title.csv / schedule.csv 用データを一括取得（DEV-14781）
export const exportCinemaphoneCsv = (data, loading = true) => {
  return axios({
    url: `/api/schedule/exportCinemaphoneCsv?cinemaId=${data.cinemaId}&startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
    data: {
      loading,
    },
  });
};

export const deleteSchedulesService = (data, loading = true) => {
  console.log(data);
  return axios({
    url: `/api/schedule/batchDelete?cinemaId=${data.cinemaId}` + (data.date ? `&date=${data.date}` : ""),
    method: "post",
    data: {
      loading
    },
  });
};